export const DOWNLOAD_APP_LINK = "https://69fz.adj.st?adj_t=1dm1nvrh";

export const APP_STORE_LINK = " https://69fz.adj.st?adj_t=1dm1nvrh";

export const PLAY_STORE_LINK = "https://69fz.adj.st?adj_t=1dm1nvrh";

export const APP_STORE_LINK_FOR_DOWNLOAD_APP_MODAL = "https://69fz.adj.st?adj_t=1dm1nvrh";

export const PLAY_STORE_LINK_FOR_DOWNLOAD_APP_MODAL = "https://69fz.adj.st?adj_t=1dm1nvrh";
